import processShim from "/home/user/src/Krunker_v7.1.4/src/shim/process.js";
const process = processShim;
export { process };
